module.exports = __webpack_public_path__ + "static/media/tti_easiest_way_to_move@3x.80007486.png";